/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Successful response
 * @export
 * @interface GetGlobalSettings200Response
 */
export interface GetGlobalSettings200Response {
    /**
     * 
     */
    clientRefRequired?: boolean;
    /**
     * 
     */
    clientRefEditable?: boolean;
}

/**
 * Check if a given object implements the GetGlobalSettings200Response interface.
 */
export function instanceOfGetGlobalSettings200Response(value: object): value is GetGlobalSettings200Response {
    return true;
}

export function GetGlobalSettings200ResponseFromJSON(json: any): GetGlobalSettings200Response {
    return GetGlobalSettings200ResponseFromJSONTyped(json, false);
}

export function GetGlobalSettings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGlobalSettings200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'clientRefRequired': json['clientRefRequired'] == null ? undefined : json['clientRefRequired'],
        'clientRefEditable': json['clientRefEditable'] == null ? undefined : json['clientRefEditable'],
    };
}

export function GetGlobalSettings200ResponseToJSON(json: any): GetGlobalSettings200Response {
    return GetGlobalSettings200ResponseToJSONTyped(json, false);
}

export function GetGlobalSettings200ResponseToJSONTyped(value?: GetGlobalSettings200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientRefRequired': value['clientRefRequired'],
        'clientRefEditable': value['clientRefEditable'],
    };
}

